import {StripeProductDto} from 'rest/models/StripeProductDto'
import {currencySignMap} from 'utils/currencySignMap'
import formatNumber from 'utils/formatNumber'

type Props = {
  plan: StripeProductDto
}

export default function ProductCard({plan}: Props) {
  if (!plan) {
    return null
  }
  return (
    <div className="max-w-md mt-10 p-6 rounded-2xl shadow-md border bg-white">
      <div className="mb-4">
        <h2 className="text-2xl font-bold">{plan.name}</h2>
        <p className="text-gray-700 mt-2">
          Get access to coupon management features and priority support.
        </p>
        <p className="text-3xl font-extrabold text-gray-900 mt-4">
          {currencySignMap[plan.price.currency.toLowerCase()]}
          {formatNumber(Number(plan.price.unit_amount) / 100, {decimals: 2})}
          <span className="text-lg font-medium text-gray-600">/month</span>
        </p>
      </div>

      <a
        href={plan.payment_link.url}
        target="_blank"
        rel="noopener noreferrer"
        className="block text-center w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-2 px-4 rounded-lg transition">
        Subscribe Now
      </a>
    </div>
  )
}
